export function emptyAnswer(kind) {
  if (kind === 'trend_line') return { starting_date: '', ending_date: '' };
  if (kind === 'breakout') return { rr_date: '' };
  if (kind === 'resistance') return { resist_date: '', resist_price: '' };
  if (kind === 'level') return { date: '' };
  if (kind === 'entry_choice') return { result_type: '' };
  if (kind === 'engulfing_classification') return { result: '' };
  if (kind === 'order_ticket') return { buy: '', resistance: '', support: '', stop: '' };
  return { option: '' };
}

export function answerIsComplete(kind, answer = {}) {
  const required = Object.keys(emptyAnswer(kind));
  return required.every(key => answer[key] !== '' && answer[key] !== null && answer[key] !== undefined);
}

export function selectChartDate(kind, answer, date) {
  const next = { ...answer };
  if (kind === 'trend_line') {
    if (!next.starting_date || next.ending_date) {
      next.starting_date = date;
      next.ending_date = '';
    } else if (next.starting_date !== date) {
      next.ending_date = date;
    }
  } else if (kind === 'breakout') {
    next.rr_date = date;
  } else if (kind === 'resistance') {
    next.resist_date = date;
  } else if (kind === 'level') {
    next.date = date;
  }
  return next;
}

export function buildSingleAttempt(position, elapsedSeconds, answer) {
  return {
    position: Number(position) || 0,
    elapsed_seconds: Math.max(0, Number(elapsedSeconds) || 0),
    answer: { ...answer }
  };
}

export function buildBatchAttempt(answersByPosition, elapsedByPosition, total) {
  const answers = [];
  for (let position = 0; position < total; position += 1) {
    const answer = answersByPosition[position];
    if (!answer || !answerIsComplete('choice', answer)) return null;
    answers.push(buildSingleAttempt(position, elapsedByPosition[position], answer));
  }
  return { answers };
}

export function sessionStorageKey(type, subtype) {
  return `eurekers:exercises:v1:${type}:${subtype}`;
}
